// extracted by mini-css-extract-plugin
export var columns = "Layout-module--columns--5+LW5";
export var container = "Layout-module--container--AI465";
export var footer = "Layout-module--footer--zec99";
export var header = "Layout-module--header--fYiCf";
export var left = "Layout-module--left---jgV0";
export var menu = "Layout-module--menu--WaqIN";
export var menuContainer = "Layout-module--menuContainer--jKsS7";
export var menuItem = "Layout-module--menuItem--Ux5cf";
export var right = "Layout-module--right--bvmFn";